import { useEffect } from "react";
import visitorsSource from "data/sources/visitorsSource";
import { VISITORS_LAYER_ID } from "components/layers/VisitorsLayer";

import visitorsOriginsSource from "data/sources/visitorsOriginsSource";
import { VISITORS_ORIGINS_LAYER_ID } from "components/layers/VisitorsOriginsLayer";

import visitorsDestinationSource from "data/sources/visitorsDestinationSource";
import { VISITORS_DESTINATION_LAYER_ID } from "components/layers/VisitorsDestinationLayer";

import zoomOutSource from "data/sources/zoomOutSource";
import { ZOOM_OUT_LAYER_ID } from "components/layers/ZoomOutLayer";

import zoomOutIntermediateSource from "data/sources/zoomOutIntermediateSource";
import { ZOOM_OUT_INTERMEDIATE_LAYER_ID } from "components/layers/ZoomOutIntermediateLayer";

import parseOriginTable from "data/sources/parseOriginTable";
import { initialState } from "store/initialStateSlice";
import { getPalette } from "@carto/react-ui/src/utils/palette";
import { useSelector, useDispatch } from "react-redux";
import { numberFormatter } from "utils/formatter";
import {
  addLayer,
  removeLayer,
  addSource,
  removeSource,
  addFilter,
  removeFilter,
  setViewState,
  updateLayer,
} from "@carto/react-redux";
import {
  FormControl,
  MenuItem,
  Typography,
  InputLabel,
  Select,
  Divider,
} from "@material-ui/core";
import { _FilterTypes as FilterTypes } from "@carto/react-core";
import {
  setDay,
  setWindow,
  setVisitors,
  setBreaks,
  setBreaksOrigins,
  setTravelledCountries,
  setDropAPin,
  setVisitedBrands,
  setGeobehaviour,
  setVisitorsOrigin,
} from "store/appSlice";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Button } from "@material-ui/core";
import {
  getVisitors,
  getTravelledCountries,
  getVisitedBrands,
  getGeobehaviour,
  getMinMaxQuantiles,
} from "data/models/model";
import { getEqualBreaks } from "utils/equalizer";
import { LEGEND_TYPES } from "@carto/react-ui";
import { WrapperWidgetUI } from "@carto/react-ui";
import ReactECharts from "echarts-for-react";
import { VISUALS } from "data/config";
import { setSimulationsVisible } from "store/appSlice";

const useStyles = makeStyles((theme) => ({
  visitors: {
    padding: theme.spacing(3, 3, 1.5),
  },
  newComponents: {
    marginTop: 12,
    marginBottom: 12,
  },
  buttons: {
    marginLeft: "20%",
    width: "60%",
    height: "40px",
    marginTop: 10,
    marginBottom: 10,
  },
  wrapperLeft: {
    "& .makeStyles-root-29 h6": {
      textAlign: "left",
    },
  },
}));

export default function Visitors() {
  const dispatch = useDispatch();
  const classes = useStyles();
  const visitorsOrigin = useSelector((state) => state.app.visitorsOrigin);
  const day = useSelector((state) => state.app.day);
  const window = useSelector((state) => state.app.window);
  const n_visitors = useSelector((state) => state.app.n_visitors);
  const credentials = useSelector((state) => state.carto.credentials);
  const travelledCountries = useSelector(
    (state) => state.app.travelledCountries
  );
  const visitedBrands = useSelector((state) => state.app.visitedBrands);
  const geobehaviour = useSelector((state) => state.app.geobehaviour);
  const palette = getPalette("Purp", 10);
  const reversedPalette = palette.slice().reverse();
  const BUCKETS = VISUALS.buckets;
  const BUCKETS_ORIGINS = VISUALS.buckets_origins;
  const handleButton = () => {
    dispatch(
      setViewState({
        latitude: initialState.viewState.latitude,
        longitude: initialState.viewState.longitude,
        zoom: initialState.viewState.zoom,
        hasFlight: true,
      })
    );
  };

  useEffect(() => {
    dispatch(setDropAPin(false));
  }, []);

  function handleDayChange(e) {
    var value = e.target.value;
    dispatch(setDay(value));

    dispatch(
      removeFilter({
        id: visitorsSource.id,
        column: "day_of_week",
      })
    );

    dispatch(
      addFilter({
        id: visitorsSource.id,
        column: "day_of_week",
        type: FilterTypes.IN,
        values: value,
        owner: "dayList",
      })
    );

    if (visitorsOrigin) {
      dispatch(
        removeFilter({
          id: visitorsOriginsSource.id,
          column: "day_of_week",
        })
      );

      dispatch(
        addFilter({
          id: visitorsOriginsSource.id,
          column: "day_of_week",
          type: FilterTypes.IN,
          values: value,
          owner: "dayList",
        })
      );
      dispatch(
        removeFilter({
          id: zoomOutSource.id,
          column: "day_of_week",
        })
      );

      dispatch(
        addFilter({
          id: zoomOutSource.id,
          column: "day_of_week",
          type: FilterTypes.IN,
          values: value,
          owner: "dayList",
        })
      );

      dispatch(
        removeFilter({
          id: zoomOutIntermediateSource.id,
          column: "day_of_week",
        })
      );

      dispatch(
        addFilter({
          id: zoomOutIntermediateSource.id,
          column: "day_of_week",
          type: FilterTypes.IN,
          values: value,
          owner: "dayList",
        })
      );

      getMinMaxQuantiles({
        credentials,
        day_of_week: value,
        part_of_day: window,
        geoid: visitorsOrigin,
        buckets: BUCKETS_ORIGINS,
      }).then((results) => {
        var breaks_layer = getEqualBreaks(
          results[0].min,
          results[0].max,
          BUCKETS_ORIGINS
        );
        breaks_layer.push("100000000");
        dispatch(setBreaksOrigins(breaks_layer));
        var layerConfig = {
          title: "Number of visitors",
          // changing visible to true will make it show up on the map by default
          visible: false,
          switchable: false,
          legend: {
            attr: VISUALS.attr,
            type: LEGEND_TYPES.BINS,
            labels: getEqualBreaks(
              results[0].min,
              results[0].max,
              BUCKETS_ORIGINS
            ),
            colors: ["#fcde9c", "#e34f6f", "#7c1d6f"],
            collapsible: false,
          },
        };
        dispatch(
          updateLayer({
            id: VISITORS_LAYER_ID,
            layerAttributes: {
              ...layerConfig,
            },
          })
        );
      });
    }
  }

  function handleWindowChange(e) {
    var value = e.target.value;
    dispatch(setWindow(value));

    dispatch(
      removeFilter({
        id: visitorsSource.id,
        column: "part_of_day",
      })
    );

    dispatch(
      addFilter({
        id: visitorsSource.id,
        column: "part_of_day",
        type: FilterTypes.IN,
        values: value,
        owner: "windowList",
      })
    );

    if (visitorsOrigin) {
      dispatch(
        removeFilter({
          id: visitorsOriginsSource.id,
          column: "part_of_day",
        })
      );

      dispatch(
        addFilter({
          id: visitorsOriginsSource.id,
          column: "part_of_day",
          type: FilterTypes.IN,
          values: value,
          owner: "windowList",
        })
      );
      dispatch(
        removeFilter({
          id: zoomOutSource.id,
          column: "part_of_day",
        })
      );

      dispatch(
        addFilter({
          id: zoomOutSource.id,
          column: "part_of_day",
          type: FilterTypes.IN,
          values: value,
          owner: "windowList",
        })
      );

      dispatch(
        removeFilter({
          id: zoomOutIntermediateSource.id,
          column: "part_of_day",
        })
      );

      dispatch(
        addFilter({
          id: zoomOutIntermediateSource.id,
          column: "part_of_day",
          type: FilterTypes.IN,
          values: value,
          owner: "windowList",
        })
      );

      getMinMaxQuantiles({
        credentials,
        day_of_week: day,
        part_of_day: value,
        geoid: visitorsOrigin,
        buckets: BUCKETS_ORIGINS,
      }).then((results) => {
        var breaks_layer = getEqualBreaks(
          results[0].min,
          results[0].max,
          BUCKETS_ORIGINS
        );
        breaks_layer.push("100000000");
        dispatch(setBreaksOrigins(breaks_layer));
        var layerConfig = {
          title: "Number of visitors",
          // changing visible to true will make it show up on the map by default
          visible: false,
          switchable: false,
          legend: {
            attr: VISUALS.attr,
            type: LEGEND_TYPES.BINS,
            labels: getEqualBreaks(
              results[0].min,
              results[0].max,
              BUCKETS_ORIGINS
            ),
            colors: ["#fcde9c", "#e34f6f", "#7c1d6f"],
            collapsible: false,
          },
        };
        dispatch(
          updateLayer({
            id: VISITORS_LAYER_ID,
            layerAttributes: {
              ...layerConfig,
            },
          })
        );
      });
    }
  }

  useEffect(() => {
    dispatch(setSimulationsVisible(false));
    dispatch(
      setViewState({
        longitude: initialState.viewState.longitude,
        latitude: initialState.viewState.latitude,
        zoom: 12,
        hasFlight: true,
        dragRotate: false,
        pitch: 0,
        transitionDuration: 500,
      })
    );
    return () => {};
  }, [dispatch]);

  //VISITORS SOURCE
  useEffect(() => {
    dispatch(addSource(visitorsSource));
    dispatch(
      addLayer({
        id: VISITORS_LAYER_ID,
        source: visitorsSource.id,
      })
    );

    dispatch(
      addFilter({
        id: visitorsSource.id,
        column: "day_of_week",
        type: FilterTypes.IN,
        values: day,
        owner: "dayList",
      })
    );

    dispatch(
      addFilter({
        id: visitorsSource.id,
        column: "part_of_day",
        type: FilterTypes.IN,
        values: window,
        owner: "windowList",
      })
    );

    return () => {
      dispatch(removeLayer(VISITORS_LAYER_ID));
      dispatch(removeSource(visitorsSource.id));
    };
  }, [dispatch]);

  // //ORIGINS

  useEffect(() => {
    if (visitorsOrigin) {
      dispatch(
        addSource(parseOriginTable(visitorsOriginsSource, visitorsOrigin))
      );
      dispatch(
        addLayer({
          id: VISITORS_ORIGINS_LAYER_ID,
          source: visitorsOriginsSource.id,
          layerAttributes: {
            visible: true,
          },
        })
      );
      dispatch(
        addFilter({
          id: visitorsOriginsSource.id,
          column: "day_of_week",
          type: FilterTypes.IN,
          values: day,
          owner: "dayList",
        })
      );

      dispatch(
        addFilter({
          id: visitorsOriginsSource.id,
          column: "part_of_day",
          type: FilterTypes.IN,
          values: window,
          owner: "windowList",
        })
      );

      return () => {
        dispatch(removeLayer(VISITORS_ORIGINS_LAYER_ID));
        dispatch(removeSource(visitorsOriginsSource.id));
        dispatch(setVisitorsOrigin(null));
      };
    }
  }, [dispatch, visitorsOrigin]);

  // Destination output
  useEffect(() => {
    dispatch(addSource(visitorsDestinationSource));
    dispatch(
      addLayer({
        id: VISITORS_DESTINATION_LAYER_ID,
        source: visitorsDestinationSource.id,
        layerAttributes: {
          visible: false,
        },
      })
    );

    return () => {
      dispatch(removeLayer(VISITORS_DESTINATION_LAYER_ID));
      dispatch(removeSource(visitorsDestinationSource.id));
    };
  }, [dispatch]);

  // // ZoomOut Layer
  useEffect(() => {
    if (visitorsOrigin) {
      dispatch(addSource(parseOriginTable(zoomOutSource, visitorsOrigin)));
      dispatch(
        addLayer({
          id: ZOOM_OUT_LAYER_ID,
          source: zoomOutSource.id,
          layerAttributes: {
            visible: true,
          },
        })
      );

      dispatch(
        addFilter({
          id: zoomOutSource.id,
          column: "day_of_week",
          type: FilterTypes.IN,
          values: day,
          owner: "dayList",
        })
      );

      dispatch(
        addFilter({
          id: zoomOutSource.id,
          column: "part_of_day",
          type: FilterTypes.IN,
          values: window,
          owner: "windowList",
        })
      );

      return () => {
        dispatch(removeLayer(ZOOM_OUT_LAYER_ID));
        dispatch(removeSource(zoomOutSource.id));
      };
    }
  }, [dispatch, visitorsOrigin]);

  // ZoomOutIntermediate Layer
  useEffect(() => {
    if (visitorsOrigin) {
      dispatch(
        addSource(parseOriginTable(zoomOutIntermediateSource, visitorsOrigin))
      );
      dispatch(
        addLayer({
          id: ZOOM_OUT_INTERMEDIATE_LAYER_ID,
          source: zoomOutIntermediateSource.id,
          layerAttributes: {
            visible: true,
          },
        })
      );

      dispatch(
        addFilter({
          id: zoomOutIntermediateSource.id,
          column: "day_of_week",
          type: FilterTypes.IN,
          values: day,
          owner: "dayList",
        })
      );

      dispatch(
        addFilter({
          id: zoomOutIntermediateSource.id,
          column: "part_of_day",
          type: FilterTypes.IN,
          values: window,
          owner: "windowList",
        })
      );

      return () => {
        dispatch(removeLayer(ZOOM_OUT_INTERMEDIATE_LAYER_ID));
        dispatch(removeSource(zoomOutIntermediateSource.id));
      };
    }
  }, [dispatch, visitorsOrigin]);

  //SQL API
  useEffect(() => {
    getVisitors({
      credentials,
      day_of_week: day,
      part_of_day: window,
      geoid: visitorsOrigin,
    }).then((results) => {
      dispatch(setVisitors(results.n_visitors));
    });

    getMinMaxQuantiles({
      credentials,
      day_of_week: day,
      part_of_day: window,
      geoid: visitorsOrigin,
      buckets: BUCKETS,
    }).then((results) => {
      dispatch(setBreaks(results[0].quantiles.slice(1)));

      if (!visitorsOrigin) {
        var layerConfig = {
          legend: {
            attr: VISUALS.attr,
            type: LEGEND_TYPES.BINS,
            labels: results[0].quantiles.slice(1, -1),
            colors: VISUALS.primary_palette,
            collapsible: true,
          },
        };
        dispatch(
          updateLayer({
            id: VISITORS_LAYER_ID,
            layerAttributes: {
              ...layerConfig,
            },
          })
        );
      }
    });

    getTravelledCountries({
      credentials,
      day_of_week: day,
      part_of_day: window,
      geoid: visitorsOrigin,
    }).then((results) => {
      dispatch(setTravelledCountries(results));
    });

    getVisitedBrands({
      credentials,
      day_of_week: day,
      part_of_day: window,
      geoid: visitorsOrigin,
    }).then((results) => {
      dispatch(setVisitedBrands(results));
    });

    getGeobehaviour({
      credentials,
      day_of_week: day,
      part_of_day: window,
      geoid: visitorsOrigin,
    }).then((results) => {
      dispatch(setGeobehaviour(results));
    });
  }, [day, window, visitorsOrigin]);

  return (
    <Grid container direction="column">
      <Grid>
        <WrapperWidgetUI
          title="Temporal aggregation"
          className={classes.wrapperLeft}
        >
          <Grid>
            <FormControl className={classes.newComponents}>
              <InputLabel id="simple-label">Weekday</InputLabel>
              <Select
                labelId="dayListLabel"
                id="dayList"
                value={day}
                onChange={handleDayChange}
              >
                <MenuItem value={"All"}>All</MenuItem>
                <MenuItem value={"Monday"}>Monday</MenuItem>
                <MenuItem value={"Tuesday"}>Tuesday</MenuItem>
                <MenuItem value={"Wednesday"}>Wednesday</MenuItem>
                <MenuItem value={"Thursday"}>Thursday</MenuItem>
                <MenuItem value={"Friday"}>Friday</MenuItem>
                <MenuItem value={"Saturday"}>Saturday</MenuItem>
                <MenuItem value={"Sunday"}>Sunday</MenuItem>
              </Select>
            </FormControl>
            <FormControl className={classes.newComponents}>
              <InputLabel id="simple-label">Time of day</InputLabel>
              <Select
                labelId="windowListLabel"
                id="windowList"
                value={window}
                onChange={handleWindowChange}
              >
                <MenuItem value={"All"}>All</MenuItem>
                <MenuItem value={"Morning"}>Morning</MenuItem>
                <MenuItem value={"Afternoon"}>Afternoon</MenuItem>
                <MenuItem value={"Evening"}>Evening</MenuItem>
                <MenuItem value={"Night"}>Night</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </WrapperWidgetUI>
      </Grid>
      <Divider></Divider>
      <WrapperWidgetUI title="Visitors data" className={classes.wrapperLeft}>
        <Typography variant="subtitle1" className={classes.newComponents}>
          {`${numberFormatter(n_visitors)}`} visitors to the area
        </Typography>
        <Typography variant="body2" className={classes.newComponents}>
          Visitors' top 10 visited countries
        </Typography>
        {travelledCountries ? (
          <ReactECharts
            option={{
              tooltip: {
                trigger: "item",
                formatter: "{a} <br/>{b} : {d}%",
              },
              series: [
                {
                  name: "Visited countries",
                  type: "pie",
                  animationDuration: 2000,
                  animationEasing: "quarticInOut",
                  radius: ["35%", "55%"],
                  avoidLabelOverlap: false,
                  startAngle: 90,
                  hoverOffset: 5,
                  color: reversedPalette,
                  data: travelledCountries,
                  itemStyle: {
                    emphasis: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: "rgba(0, 0, 0, 0.5)",
                    },
                  },
                },
              ],
            }}
            style={{ height: 275 }}
          />
        ) : null}

        <Typography variant="body2" className={classes.newComponents}>
          Visitors' top 10 visited brands
        </Typography>
        {visitedBrands ? (
          <ReactECharts
            option={{
              tooltip: {
                trigger: "item",
                formatter: "{a} <br/>{b} : {d}%",
              },
              series: [
                {
                  name: "Visited brands",
                  type: "pie",
                  animationDuration: 2000,
                  animationEasing: "quarticInOut",
                  radius: ["35%", "55%"],
                  avoidLabelOverlap: true,
                  startAngle: 90,
                  hoverOffset: 2,
                  color: reversedPalette,
                  data: visitedBrands,
                  itemStyle: {
                    emphasis: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: "rgba(0, 0, 0, 0.5)",
                    },
                  },
                },
              ],
            }}
            style={{ height: 275 }}
          />
        ) : null}

        <Typography variant="body2" className={classes.newComponents}>
          Visitors' top 10 consume profiles
        </Typography>
        {geobehaviour ? (
          <ReactECharts
            option={{
              tooltip: {
                trigger: "item",
                formatter: "{a} <br/>{b} : {d}%",
              },
              series: [
                {
                  name: "Visitors profiles",
                  type: "pie",
                  animationDuration: 2000,
                  animationEasing: "quarticInOut",
                  radius: ["35%", "55%"],
                  avoidLabelOverlap: true,
                  startAngle: 90,
                  hoverOffset: 2,
                  color: reversedPalette,
                  data: geobehaviour,
                  itemStyle: {
                    emphasis: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: "rgba(0, 0, 0, 0.5)",
                    },
                  },
                },
              ],
            }}
            style={{ height: 275 }}
          />
        ) : null}
      </WrapperWidgetUI>
      <Divider></Divider>
      <Button
        variant="contained"
        className={classes.buttons}
        variant="contained"
        color="primary"
        size="small"
        align="center"
        onClick={handleButton}
      >
        Back to London
      </Button>
    </Grid>
  );
}
